import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './components/App';
import Landing from './containers/Landing/Landing';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={Landing}/>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js